import { eagerGet } from '@/utils/eager'
import toasted from '@/utils/toasted'
import { isObjectEmpty } from '@/utils/object'
import hash from 'object-hash'

const mixin = {
  props: {
    redirectAfterCreate: String,
    idParent: String,
    shouldNotUpdate: {
      type: Boolean,
      default: true,
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.getters['modif/formModified']) {
      this.modalLeave = true
      this.next = next
    } else {
      next()
    }
  },
  data() {
    return {
      id: null,
      namespace: null,
      saving: false,
      form: {},
      parentToKeep: null,
      initialFormDigest: null,
      modalLeave: false,
      disableFirstClick: false,
      next: () => {},
      updateMode: true,
      createMode: false,
    }
  },
  provide() {
    return {
      namespace: this.namespace,
      $vroot: this.$v,
    }
  },
  mounted() {
    let loaded = eagerGet()
    this.id = loaded.id
    const savedInput = this.loadSavedInput()
    loaded = savedInput !== undefined ? savedInput : loaded // si on a rien chargé, on reprend l'ancien état de remplissage du formulaire
    if (!isObjectEmpty(loaded)) {
      this.initForm(loaded)
    }
    this.updateMode = true

    this.$nextTick(() => this.setInitialFormDigest())
  },
  beforeDestroy() {
    toasted.clear()
  },
  computed: {
    tableLinkName() {
      return this.namespace + '/liste'
    },
    linkName() {
      return this.namespace + '/detail'
    },
    updateURI() {
      return this.namespace + '/' + this.id
    },
    createURI() {
      return this.namespace
    },
    // updateMode() {
    //   return this.id !== undefined && this.id != null;
    // },
    // createMode() {
    //   return this.id === undefined || this.id == null;
    // },
    hasBeenModified() {
      return !(
        hash(this.form, { unorderedArrays: true }) === this.initialFormDigest
      )
    },
  },
  methods: {
    refreshView() {
      this.$api(this.createURI)
        .get()
        .then((response) => {
          this.initForm(response.body)
          this.setInitialFormDigest()
          this.$emit('formRefreshed')
          toasted.info('form.reloaded')
        })
        .catch(() => {
          // todo
        })
    },

    update() {
      const api = this.$api(this.updateURI)
      this.saving = true
      return api
        .post(this.form)
        .then(
          (response) => {
            Object.assign(this.form, response.body)
            this.form.updated = response.body.updated

            this.$emit('formUpdatedOnBack')

            // On copie initialformdigest devient le hash du form courrant
            // attention il faut le faire apres formUpdatedOnBack qui peut modifier des informations du formulaire
            this.setInitialFormDigest()
            toasted.info('form.saved')
          },
          (error) => {
            this.$emit('updateCatchException', error)
          },
        )
        .finally(() => {
          this.saving = false
          this.disableFirstClick = false
        })
    },
    save() {
      this.$v.$touch()
      if (this.$v.form.$invalid) {
        toasted.error('form.error')
        return Promise.reject('form.error')
      } else {
        this.disableFirstClick = true
        if (this.updateMode) {
          return this.update()
        }
      }
    },
    errorHandler(error) {
      toasted.error(error.message)
    },
    setInitialFormDigest() {
      this.initialFormDigest = hash(this.form, { unorderedArrays: true })
    },
    loadSavedInput() {
      if (this.$store.state.form !== undefined) {
        const oldState = this.$store.state.form[this.namespace]

        if (oldState !== undefined) {
          this.$store.commit('form/saveFormProgression', {
            form: this.namespace,
            value: undefined,
          })
        }
        return oldState
      }
    },
  },
  watch: {
    '$route.params.id': function () {
      if (this.$route.params.id && this.$route.params.id !== 'new') {
        if (!this.$route.params.shouldNotUpdate) {
          this.id = this.$route.params.id
          this.refreshView()
        }
      } else {
        this.id = undefined
        this.initForm({})
        this.setInitialFormDigest()
      }
    },
    hasBeenModified(val) {
      this.$store.commit('modif/modified', val)
    },
  },
}

export default mixin
